export default class WmsTransactionEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#wms_transaction_uuid") ? (elem.querySelector("#wms_transaction_uuid") as HTMLInputElement).value : null,
        }
    }
}